<!--体围测量 -->
<template>
    <div>
        <div class="tabel-box">
            <div class="centent-comment-title">体围测量<span
                    style="font-weight: 400;font-size: 17px;color: #333333;">&nbsp;cm</span></div>
            <div style="text-align: left; font-weight: 400;
font-size: 9px;color: #7F7F7F; margin-top: 4px;">*为保障数据精确性，需穿着紧身衣物<span style="font-weight: 400;
font-size: 9px;
color: #333;">&nbsp;高精度</span></div>
            <!-- 表格内容 -->
            <div class="table-content">
                <div class="tabel-title">
                    <div class="tabel-item-title " style="width: 110px; text-align: left;">&nbsp;&nbsp;项目</div>
                    <div class="tabel-item-title mr" style="width: 136px;">本次</div>
                    <div class="tabel-item-title mr" style="width: 136px;">与上次对比</div>
                </div>
                <div v-for="(item, index) in items" :v-bind="index" :key="index" v-if="items">
                    <div class="line-div"></div>
                    <div class="tabel-title">
                        <div class="tabel-item-left-title" style="width: 110px; text-align: left;">&nbsp;&nbsp;{{
                    item.title }}</div>
                        <div class="tabel-item-right-content" style="width: 136px;">{{ item.value }}</div>
                        <div class="tabel-item-right-content" style="width: 136px;">{{ item.last }}</div>
                    </div>
                   
                </div>
            </div>

        </div>
    </div>

</template>
<script>

export default {
    props: {
        reportResult: {
            type: Object,
            required: true
        },
    },
    data() {
        return {
            items: []
        }
    },
    mounted() {
        console.log('------------------================');
        console.log(this.reportResult);
        if (this.reportResult.physicalResultLast) {
            this.items.push({
                title: '左臂长',
                value: (this.reportResult.physicalResult.leftArm / 10).toFixed(1) + 'cm',
                last: this.calculationLast(this.reportResult.physicalResult.leftArm, this.reportResult.physicalResultLast.leftArm)
            })
            this.items.push({
                title: '右臂长',
                value: (this.reportResult.physicalResult.rightArm / 10).toFixed(1) + 'cm',
                last: this.calculationLast(this.reportResult.physicalResult.rightArm, this.reportResult.physicalResultLast.rightArm)
            })
            this.items.push({
                title: '左大腿',
                value: (this.reportResult.physicalResult.leftThigh / 10).toFixed(1) + 'cm',
                last: this.calculationLast(this.reportResult.physicalResult.leftThigh, this.reportResult.physicalResultLast.leftThigh)
            })
            this.items.push({
                title: '右大腿',
                value: (this.reportResult.physicalResult.rightThigh / 10).toFixed(1) + 'cm',
                last: this.calculationLast(this.reportResult.physicalResult.rightThigh, this.reportResult.physicalResultLast.rightThigh)
            })
            this.items.push({
                title: '左小腿',
                value: (this.reportResult.physicalResult.leftCalf / 10).toFixed(1) + 'cm',
                last: this.calculationLast(this.reportResult.physicalResult.leftCalf, this.reportResult.physicalResultLast.leftCalf)
            })
            this.items.push({
                title: '右小腿',
                value: (this.reportResult.physicalResult.rightCalf / 10).toFixed(1) + 'cm',
                last: this.calculationLast(this.reportResult.physicalResult.rightCalf, this.reportResult.physicalResultLast.rightCalf)
            })
        } else {
            this.items.push({ title: '左臂长', value: (this.reportResult.physicalResult.leftArm / 10).toFixed(1) + 'cm', last: "" })
            this.items.push({ title: '右臂长', value: (this.reportResult.physicalResult.rightArm / 10).toFixed(1) + 'cm', last: "" })
            this.items.push({ title: '左大腿', value: (this.reportResult.physicalResult.leftThigh / 10).toFixed(1) + 'cm', last: "" })
            this.items.push({ title: '右大腿', value: (this.reportResult.physicalResult.rightThigh / 10).toFixed(1) + 'cm', last: "" })
            this.items.push({ title: '左小腿', value: (this.reportResult.physicalResult.leftCalf / 10).toFixed(1) + 'cm', last: "" })
            this.items.push({ title: '右小腿', value: (this.reportResult.physicalResult.rightCalf / 10).toFixed(1) + 'cm', last: "" })
        }

    },

    methods: {
        calculationLast(value, lastValue) {
            if (value > lastValue) {
                return "+" + Math.abs((value - lastValue) / 10).toFixed(1)
            } else if (value < lastValue) {
                return "-" + Math.abs((value - lastValue) / 10).toFixed(1)
            } else {
                return ""
            }
        }
    }
}
</script>

<style scoped>
/* 内容局域  头部文字的公共样式*/
.centent-comment-title {
    font-size: 19px;
    color: #333333;
    font-weight: bold;
    text-align: left;
}

/* 总表格横向列排列 */
.tabel-box {
    display: flex;
    flex-direction: column;
}

.table-content {
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    border: 1px solid #F0F9F6;
}

.tabel-title {
    display: flex;
    flex-direction: row;
}

.tabel-item-left-title {
    font-weight: 500;
    font-size: 13px;
    color: #333333;
    height: 52px;
    align-items: center;
    display: flex;
}

.tabel-item-right-content {
    font-weight: 500;
    font-size: 13px;
    color: #333333;
    height: 50px;
    justify-content: center;
    align-items: center;
    display: flex;
    border-left: 1px solid #F0F9F6;
}

.tabel-item-title {
    font-weight: 400;
    font-size: 13px;
    color: #333333;
    height: 32px;
    line-height: 32px;
}

.line-div {
    width: 383px;
    height: 1px;
    background: #8ED1BF;
    opacity: 0.1;
}

.mr {
    margin-left: 1px;
}
</style>